import { Participant } from '@app/models'

export const getEmailWithFallback = (
  participant: Participant | null
): string => {
  if (!participant) return ''
  return participant.originalEmail || participant.aliasEmail || ''
}
